import React, { Fragment } from 'react'
import { Box, Tabs } from 'stylist'
import withProduct from 'components/withProduct'
import InfoGroup from 'components/InfoGroup'
import Subheader from 'components/Subheader'
import RelationshipContainer from 'components/RelationshipContainer'
import { Switch, Route } from 'react-router-dom'
import RouteProductServers from 'routes/admin/products/servers'
import RouteProductServersNew from 'routes/admin/products/servers/new'
import renderValue from 'utils/renderValue'
import fields from 'fields/products'

const RouteShow = ({ product, match: { path } }) => (
  <Fragment>
    <h5>Product Information</h5>
    <Box>
      <Box.Item pad>
        {fields.map(field => (
          <InfoGroup key={field.name}>
            <Subheader>{field.label || field.name}:</Subheader>
            <span>{renderValue(product[field.name])}</span>
          </InfoGroup>
        ))}
      </Box.Item>
    </Box>

    <Tabs>
      <Tabs.Item to={`${path}/servers`}>Servers</Tabs.Item>
    </Tabs>

    <RelationshipContainer>
      <Switch>
        <Route
          path={`${path}/servers`}
          exact
          render={routeProps => (
            <RouteProductServers
              variables={{ product_id: product.id }}
              {...routeProps}
            />
          )}
        />
        <Route
          path={`${path}/servers/new`}
          exact
          render={routeProps => (
            <RouteProductServersNew product={product} {...routeProps} />
          )}
        />
      </Switch>
    </RelationshipContainer>
  </Fragment>
)

export default withProduct(RouteShow)



// WEBPACK FOOTER //
// ./src/routes/admin/products/show.js